const addClicks = (tile) => {
  if (typeof (window.dAgency.proxyLinkSetup) !== 'undefined') {
    window.dAgency.proxyLinkSetup($(tile));
  }

  const colorSwatchesContainer = tile.querySelector('.product-tile__colors[data-product-url]');
  if (colorSwatchesContainer) {
    $(colorSwatchesContainer).off('click');
    colorSwatchesContainer.addEventListener('click', (e) => {
      if (typeof (colorSwatchesContainer.dataset.productUrl) !== 'undefined') {
        if ((!e.target.classList.contains('product-tile-colors__swatch') || !e.target.closest('.product-tile-colors__swatch'))) {
          window.location.href = colorSwatchesContainer.dataset.productUrl;
        }
      }
    });
  }
};

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductTile = (tile) => {
  if (!tile) return;

  const imagesContainer = tile.querySelector('.product-tile__images');
  if (imagesContainer) {
    const prevArrow = imagesContainer.querySelector('.product-tile-images__arrow.product-tile-images__arrow--left');
    const nextArrow = imagesContainer.querySelector('.product-tile-images__arrow.product-tile-images__arrow--right');
    const progressbar = imagesContainer.querySelector('.product-tile-images__pagination');

    prevArrow.style.display = imagesContainer.querySelectorAll('.product-tile-images__single-image').length > 1 ? '' : 'none';
    nextArrow.style.display = imagesContainer.querySelectorAll('.product-tile-images__single-image').length > 1 ? '' : 'none';
    progressbar.style.display = imagesContainer.querySelectorAll('.product-tile-images__single-image').length > 1 ? '' : 'none';

    const tileGallery = new Swiper(imagesContainer, {
      loop: false,
      allowTouchMove: true,
      pagination: {
        el: imagesContainer.querySelector('.product-tile-images__pagination'),
        type: "progressbar",
        clickable: false
      },
      navigation: {
        prevEl: imagesContainer.querySelector('.product-tile-images__arrow.product-tile-images__arrow--left'),
        nextEl: imagesContainer.querySelector('.product-tile-images__arrow.product-tile-images__arrow--right')
      }
    });

    addClicks(tile);

    const colorSwatches = tile.querySelectorAll('.product-tile-colors__swatch');
    colorSwatches.forEach(swatch => {
      if (typeof (swatch.dataset.productHandle) !== 'undefined') {
        const productHandle = swatch.dataset.productHandle;
        const imageContainer = document.createElement('div');
        imageContainer.classList.add('product-tile-images__single-image');
        imageContainer.classList.add('swiper-slide');

        swatch.addEventListener('click', () => {
          if (swatch.classList.contains('product-tile-colors__swatch--active')) return;

          fetch(`/products/${productHandle}.js`, {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
            },
          })
            .then(res => res.json())
            .then(res => {
              if (typeof (res) !== 'undefined' && typeof (res.images) !== 'undefined' && res.images.length > 0) {
                imagesContainer.classList.add('loading');
                const images = res.images;

                tileGallery.removeAllSlides();
                images.forEach((image, index) => {
                  const imgTag = document.createElement('img');
                  imgTag.setAttribute('src', image);

                  const newSlide = imageContainer.cloneNode(false);
                  newSlide.appendChild(imgTag);
                  tileGallery.appendSlide(newSlide);
                });

                prevArrow.style.display = images.length > 1 ? '' : 'none';
                nextArrow.style.display = images.length > 1 ? '' : 'none';
                progressbar.style.display = images.length > 1 ? '' : 'none';

                const newProductUrl = tile.dataset.withinUrl + res.handle;
                tile.querySelectorAll('.product-tile__images').forEach(tileImages => {
                  tileImages.href = newProductUrl;
                });
                tile.querySelector('.product-tile__title').setAttribute('href', newProductUrl);
                tile.querySelectorAll('[data-product-url]').forEach(productUrls => {
                  productUrls.dataset.productUrl = newProductUrl;
                });

                tile.querySelector('[data-product-price]').textContent = theme.Currency.formatMoney(res.variants[0].price, theme.strings.moneyFormat);

                if (res.variants[0].compare_at_price) {
                  tile.querySelector('[data-product-compare-at-price]').textContent = theme.Currency.formatMoney(res.variants[0].compare_at_price, theme.strings.moneyFormat)
                  tile.querySelector('[data-product-compare-at-price]').classList.add('visible');

                  var wasPrice = res.variants[0].compare_at_price / 100;
                  var newPrice = res.variants[0].price / 100;
                  var discount = 100 - (newPrice / wasPrice) * 100;

                  tile.querySelector('[data-product-percentage]').textContent = '-' + Math.ceil(discount) + '%';
                  tile.querySelector('[data-product-percentage]').classList.add('visible');
                } else {
                  tile.querySelector('[data-product-compare-at-price]').textContent = '';
                  tile.querySelector('[data-product-compare-at-price]').classList.remove('visible');
                  tile.querySelector('[data-product-percentage]').textContent = '';
                  tile.querySelector('[data-product-percentage]').classList.remove('visible');
                }

                if (res.variants[0].available) {
                  tile.querySelector('[data-product-oos]').classList.remove('visible');
                } else {
                  tile.querySelector('[data-product-oos]').classList.add('visible');
                }

                addClicks(tile);

                const activeColor = tile.querySelector('.product-tile-colors__swatch.product-tile-colors__swatch--active');
                if (activeColor) activeColor.classList.remove('product-tile-colors__swatch--active');
                swatch.classList.add('product-tile-colors__swatch--active');
                imagesContainer.classList.remove('loading');
              }
            }).catch(err => {
              console.error(err);
            });
        });
      }
    });

    tile.classList.add('product-tile__container--initialized');
  }
};

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.product-tile__container'), (tile) => {
    window.dAgency.initProductTile(tile);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-tile__container'), (tile) => {
      window.dAgency.initProductTile(tile);
    });
  });
}
